// src/App.jsx
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import About from './pages/about';
import Contact from "./pages/Contact";
import Cursor from './components/Cursor';
import Portfolio from './pages/Portfolio';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import RefundPolicy from './pages/RefundPolicy';
import StarBackground from './components/StarBackground';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Preloader from './components/Preloader';
import AIChatbot from './components/AIChatbot';
import { SiteContentProvider } from './context/SiteContentContext';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';

// ─── Service Pages ───────────────────────────────────────────
import WebMobileApps from './pages/services/WebMobileApps';
import CmsEcommerce from './pages/services/CmsEcommerce';
import DigitalMarketing from './pages/services/DigitalMarketing';
import GraphicDesign from './pages/services/GraphicDesign';
import UiUxDesign from './pages/services/UiUxDesign';
import AiTechnologies from './pages/services/AiTechnologies';

// ─── Industry Pages ──────────────────────────────────────────
import Healthcare from './pages/industries/Healthcare';
import Fitness from './pages/industries/Fitness';
import HomeServices from './pages/industries/HomeServices';
import RealEstate from './pages/industries/RealEstate';
import Ecommerce from './pages/industries/Ecommerce';
import Restaurant from './pages/industries/Restaurant';
import Coaching from './pages/industries/Coaching';
import Education from './pages/industries/Education';

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  // ── Toggle cursor-none-mode class on body based on route ──────────────
  useEffect(() => {
    if (isAdmin) {
      document.body.classList.remove('cursor-none-mode');
    } else {
      document.body.classList.add('cursor-none-mode');
    }
    return () => {
      document.body.classList.remove('cursor-none-mode');
    };
  }, [isAdmin]);

  return (
    <Preloader>
      <div className="text-white min-h-screen font-sans selection:bg-[#F3CA52] selection:text-black relative">
        <StarBackground />
        {!isAdmin && <Cursor />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/term" element={<TermsOfUse />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />

          {/* ── Service Pages ── */}
          <Route path="/services/web-mobile-apps" element={<WebMobileApps />} />
          <Route path="/services/cms-ecommerce" element={<CmsEcommerce />} />
          <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/services/graphic-design" element={<GraphicDesign />} />
          <Route path="/services/ui-ux-design" element={<UiUxDesign />} />
          <Route path="/services/ai-technologies" element={<AiTechnologies />} />

          {/* ── Industry Pages ── */}
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/fitness" element={<Fitness />} />
          <Route path="/industries/home-services" element={<HomeServices />} />
          <Route path="/industries/real-estate" element={<RealEstate />} />
          <Route path="/industries/ecommerce" element={<Ecommerce />} />
          <Route path="/industries/restaurant" element={<Restaurant />} />
          <Route path="/industries/coaching" element={<Coaching />} />
          <Route path="/industries/education" element={<Education />} />
          {/* ── Admin CMS Dashboard Routes ── */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <AIChatbot />
      </div>
    </Preloader>
  );
}

function App() {
  return (
    <SiteContentProvider>
      <Router>
        <AppContent />
      </Router>
    </SiteContentProvider>
  );
}

export default App;